import Cookies from 'js-cookie';

export const getAIErrorMessage = (
  err: unknown,
  fallback: string
): string => {
  if (typeof err === 'string') return err;
  if (err instanceof Error && err.message) return err.message;

  const payload = err as Record<string, unknown> | null | undefined;
  const message = payload?.error || payload?.detail || payload?.message;

  return typeof message === 'string' ? message : fallback;
};

export const throwIfAIResponseNotOk = async (
  response: Response
): Promise<void> => {
  if (response.ok) return;

  let errorPayload: unknown = null;
  try {
    errorPayload = await response.json();
  } catch {
    errorPayload = { message: await response.text() };
  }

  throw new Error(
    getAIErrorMessage(
      errorPayload,
      `HTTP error! status: ${response.status}`
    )
  );
};

export interface AutoGeneratedCultureProfileResponse {
  name?: string;
  Competencies?: number[];
  competencies?: number[];
}

/** Generate culture profile competencies from a company website URL. */
export const postAutoGenerateCultureCompetencies = async (
  url: string,
  signal?: AbortSignal
): Promise<AutoGeneratedCultureProfileResponse> => {
  const accessToken = Cookies.get('accesstoken');
  const response = await fetch('/api/ai/culture_competencies/', {
    method: 'POST',
    signal,
    headers: {
      'Content-Type': 'application/json',
      ...(accessToken && { Authorization: `Bearer ${accessToken}` })
    },
    body: JSON.stringify({ url })
  });

  await throwIfAIResponseNotOk(response);

  const raw = await response.text();
  return JSON.parse(raw.trimStart());
};
